import React from 'react';
import PropTypes from 'prop-types';

import { Text } from 'components/core/Typography';

export default function DefaultLabel({ labelSize, label }) {
	return (
		<Text size={labelSize} className="review-count">
			{' '}- based on {label}
		</Text>
	);
}

DefaultLabel.propTypes = {
	labelSize: PropTypes.string,
	label: PropTypes.string
};
